import { UserRoleType } from '../users/users.types';

export enum AppSectionCode {
  ADMIN = 'admin',
  ANALYTICS = 'analytics',
  ADV = 'adv',
  CONTROL = 'control',
  EXPEDITION = 'dispatch',
  GRADE = 'grade',
  MATCHING = 'matching',
  MANAGEMENT = 'management',
  PRODUCTION = 'production',
  PREPARATION = 'prepare',
  PURCHASE = 'purchase',
  REPAIR = 'repair',
  SAV = 'sav',
  SPECIAL_PROCESS = 'specialprocess',
  ACCOUNTING = 'accounting',
  BUYBACK = 'buyback',
  CRM = 'crm'
}

export interface AppSection {
  public: boolean;
  code: AppSectionCode;
  icon: string; // Font Awesome icon class
  name: string;
  access: UserRoleType[];
  excludeAccess?: UserRoleType[];
  subSections?: AppSubSection[];
  stockName?: string;
}
export interface AppSubSection {
  code: string;
  name: string;
  public?: boolean;
  desc?: string;
  icon?: string;
  subSections?: AppSubSection[];
}

export type SectionsDico = Record<string, AppSection | AppSubSection>;
